import { render } from "./gmAbnormalCallListNew.vue?vue&type=template&id=19ab0774&scoped=true"
import script from "./gmAbnormalCallListNew.vue?vue&type=script&lang=js"
export * from "./gmAbnormalCallListNew.vue?vue&type=script&lang=js"

import "./gmAbnormalCallListNew.vue?vue&type=style&index=0&id=19ab0774&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19ab0774"

export default script